import { render, staticRenderFns } from "./m-editSubtopic.vue?vue&type=template&id=36aac35a&"
import script from "./m-editSubtopic.vue?vue&type=script&lang=js&"
export * from "./m-editSubtopic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports